import React from 'react';
import cn from 'classnames';
import { IIconProps } from './IIconProps';

export const InfoDangerIcon: React.FC<IIconProps> = ({
	iconClass = '',
	title = '',
	pointer,
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 20 20"
			className={cn(iconClass, { 'icon--pointer': pointer })}
			fill="none"
			width={20}
			{...props}
		>
			{title && <title>{title}</title>}
			<path
				d="M11 7H9V5H11V7ZM11 15H9V9H11V15ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
				fill="#C62828"
			/>
		</svg>
	);
};
